import { renderMarkdown } from "../../../extensions/json-schema/components/markdown";
import "./submitted-request-message.less";

interface RequestPromptForm {
	Onboarding?: {
		Requests?: {
			Interface?: {
				Prompts?: {
					Submitted?: { Message?: unknown };
				};
			};
		};
	};
}

export function getSubmittedRequestMessage(
	form: RequestPromptForm | undefined,
	fallback: string,
	sanitize: (html: string) => string
): string {
	const message = form?.Onboarding?.Requests?.Interface?.Prompts?.Submitted?.Message;
	if(typeof message !== "string" || !message.trim()) {
		return fallback;
	}

	return `<div class="onboarding-submitted-message"><div class="schema-markdown">${renderMarkdown(message, sanitize)}</div></div>`;
}
